import { useState, useEffect } from 'react';
import { fetchDataAuthenticated } from '../utilities/HttpUtils';

export function useValveStates() {

    const [loading, setLoading] = useState(true);
    const [valveStates, setValveStates] = useState([]);

    useEffect(() => {
        getValvesStates();
    }, []);

    async function getValvesStates() {

        await fetchDataAuthenticated("api/valveStates")
            .then(async response => {
                if (response.ok) {
                    return response.json();
                }
                throw new Error(await response.text());
            })
            .then(data => {
                setValveStates(data);
            })
            .catch(error => {
                console.error(error.message);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    return { valveStates, loading }
}